import { Button } from 'antd'
import dayjs from 'dayjs'
import { CSVLink } from 'react-csv'
import { buildCsvString } from 'src/utils/csv'

const SpecialPurchasesCSV = ({ specialPurchases }) => {
  const tableHeaders = [
    'Reference ID',
    'Department',
    'Manager Name',
    'Manager Email',
    'Staff Name',
    'Staff Email',
    'Item Name',
    'Item Cost (£)',
    'Created At',
    'Status',
    'Supplier',
    'SKU',
    'Justification',
    'Decline Reason',
  ]

  const dataOfTable =
    specialPurchases?.map(entry => {
      const status = entry.isApproved
        ? 'Approved'
        : entry.isDeclined
        ? 'Declined'
        : 'Pending'

      return [
        entry?.referenceNumber || '',
        entry?.department?.name || '',
        entry.managerDetails?.managerName || '',
        entry.managerDetails?.managerEmail || '',
        entry.staffDetails?.staffName || '',
        entry.staffDetails?.staffEmail || '',
        entry.itemDetails?.itemName || '',
        entry.itemDetails?.itemCost || '',
        dayjs(entry.createdAt).format('DD/MM/YYYY') || '',
        status,
        entry.supplierDetails?.title || '',
        entry.itemDetails?.sku || '',
        entry?.justification || '',
        entry?.declineReason || '',
      ]
    }) || []

  return (
    <Button
      disabled={!specialPurchases.length}
      style={{ marginLeft: '20px', width: 200, height: 40 }}
    >
      <CSVLink
        data={buildCsvString([tableHeaders, ...dataOfTable])}
        filename={`Approval_History.csv`}
      >
        Download CSV
      </CSVLink>
    </Button>
  )
}

export default SpecialPurchasesCSV
